export default {
  getCertificates: state => state.data
}



// WEBPACK FOOTER //
// ./src/store/modules/certificates/getters.js